<template>
  <nav :class="['aside-menu', { 'aside-menu--small': hasFullWidthContent }]">
    <div class="aside-menu__inner">
      <SlideContent
        class="aside-menu__slider"
        :currentIndex="currentSlideIndex"
        :isAdjustingScroll="false"
        :hasHeightAnimation="false"
        @mounted="onSlideContentMounted"
      >
        <SlideContentBlock
          v-for="(menu, menuIndex) in menus"
          :key="`contentBlock${menuIndex}`"
          :class="[
            'aside-menu__slider-block',
            {
              'aside-menu__slider-block--no-transition': !hasSlideTransition,
            },
          ]"
        >
          <AsideMenuTab
            v-for="(tab, index) in menu"
            :key="`tab-${menuIndex}-${index}`"
            :index="index"
            :tab="tab"
          />
        </SlideContentBlock>
      </SlideContent>
    </div>
  </nav>
</template>

<script>
import { SlideContent, SlideContentBlock } from '@/components/SlideContent/SlideContent.vue'
import AsideMenuTab from './AsideMenuTab.vue'

export default {
  name: 'AsideMenu',
  components: {
    SlideContent,
    SlideContentBlock,
    AsideMenuTab,
  },

  props: {
    tabs: {
      type: Array,
      default: () => [],
    },

    currentSlideIndex: {
      type: Number,
      default: 0,
    },

    hasFullWidthContent: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hasSlideTransition: false,
    }
  },

  computed: {
    menus() {
      return this.tabs.every(tab => Array.isArray(tab)) ? this.tabs : [this.tabs]
    },
  },

  methods: {
    onSlideContentMounted() {
      setTimeout(() => (this.hasSlideTransition = true), 500)
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/components/SiteContainer/site-container-settings';
@import './settings';

.aside-menu {
  display: none;
  width: 26vw;
  min-width: 200px;
  max-width: $account-menu-max-width;

  &--small {
    max-width: $account-menu-max-width-small;
  }

  @include min-screen($mq-large) {
    display: block;
  }

  @include max-screen($mq-larger) {
    max-width: 200px;
  }

  &__inner {
    position: static;
    position: sticky;
    transform: translateX($inner-translate-x);
    top: $floating-site-content-padding-top-large;
  }

  &__slider-block {
    &--no-transition {
      transition: opacity 0s !important;
    }
  }
}
</style>
